import React from "react";
import { Box, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import InputCst from "@components/InputCst/InputCst";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../../types";
import { Toggle } from "src/UI/Toggle";

interface ClassContentProps extends WizardStepProps<ActivityWizardData> {
  locked?: boolean;
}

const ClassContent: React.FC<ClassContentProps> = ({
  data,
  setData,
  errors,
  locked = false,
}) => {
  const { t } = useTranslation("wizard-activity");

  const errMsg = (key: string): string =>
    errors[key] ? t(`errors.${errors[key]}`) || "" : "";

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <InputCst
            id="activity-min-partecipant"
            label={`${t("content.class.min-partecipant")} *`}
            value={data.min_partecipant}
            onChange={(e: any) => setData({ min_partecipant: e.target.value })}
            type="number"
            min={0}
            error={!!errors.min_partecipant}
            errorMessage={errMsg("min_partecipant")}
            disabled={locked}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InputCst
            id="activity-max-partecipant"
            label={`${t("content.class.max-partecipant")} *`}
            value={data.max_partecipant}
            onChange={(e: any) => setData({ max_partecipant: e.target.value })}
            type="number"
            min={0}
            error={!!errors.max_partecipant}
            errorMessage={errMsg("max_partecipant")}
          />
        </Grid>
      </Grid>

      <Toggle
        label={t("content.class.self-enrollment")}
        checked={data.self_enrollment}
        onChange={(next) => setData({ self_enrollment: next })}
      />
    </Box>
  );
};

export default ClassContent;
